import React, { Component } from "react";
import { withTheme, withStyles } from "@material-ui/core/styles";
import {
  Fab,
  Grid,
  Paper,
  Divider,
  Typography,
  IconButton,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos"; // Changed to match ProjectsMasterPanel
import {
  TextInput,
  FormattedMessage,
  formatMessage,
  ControlledField,
  PublishedComponent,
  historyPush,
  journalize,
} from "@openimis/fe-core";
import {
  savePREAUTHS,
  fetchMyPreauthorization,
  approvePreauthorization,
  rejectPreauthorization,
  fetchUserClaimAdmin,
} from "../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Save } from "@material-ui/icons"; // Removed KeyboardBackspace since we're using ArrowBackIos
import { injectIntl } from "react-intl";
import PreauthorizationConfirmation from "../components/PreauthorizationConfirmation";

import {
  RIGHT_PREAUTHORIZATION_APPROVE,
  RIGHT_PREAUTHORIZATION_REJECT,
} from "../constants";

const styles = (theme) => ({
  paper: theme.paper.paper,
  tableTitle: theme.table.title,
  item: theme.paper.item,
  fullHeight: {
    height: "100%",
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    backgroundColor: "#b7d4d8",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
  backButton: {
    marginRight: theme.spacing(1),
    color: "#006273",
  },
  titleText: {
    color: "#006273",
    fontWeight: 500,
    fontSize: 23,
  },
});

class AddPreauth extends Component {
  state = {
    edited: {
      praStatus: "E",
    },
    preauth_uuid: null,
    open: false,
    action: null,
    title: "",
    disablePage: false,
    showPopUp: false,
  };

  componentDidMount() {
    // get the url
    const url = window.location.href;
    const urlParts = url.split("/");
    //collect the uuid from the url
    const preauth_uuid = urlParts[urlParts.length - 1];
    this.props.fetchUserClaimAdmin();

    console.log("Component mounting, preauth_uuid:", preauth_uuid);

    if (preauth_uuid) {
      // Fetch preauthorizations data
      this.props.fetchMyPreauthorization(this.props.modulesManager).then(() => {
        console.log("Fetched preauthorizations:", this.props.preauthorizations);

        // Now that data is fetched and available in this.props.preauthorizations
        //find the item with the collected uuid
        const preauthorization = this.props.preauthorizations.find(
          (preath) => preath.uuid === preauth_uuid
        );

        console.log("Found preauthorization:", preauthorization);

        if (preauthorization) {
          this.setState((prevState) => ({
            ...prevState,
            edited: preauthorization,
            preauth_uuid: preauth_uuid,
          }));
        }
      });
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.submittingMutation && !this.props.submittingMutation) {
      this.props.journalize(this.props.mutation);
      this.setState((prevState) => ({
        ...prevProps,
        showPopUp: true,
      }));
    }
  }

  save = () => {
    console.log("Beginning save with state:", this.state.edited);

    // Create a properly formatted preauth object for submission
    const preauth = {
      ...this.state.edited,
      praStatus: this.state.edited.praStatus || "E",

      // Make sure we extract IDs from objects or use direct values
      enrolleeId:
        this.state.edited.insureeId ||
        (this.state.edited?.enrollee && this.state.edited.enrollee.id) ||
        this.state.edited.enrollee,

      refHfFromId:
        this.state.edited.refHfFromId ||
        (typeof this.state.edited.refHfFrom === "object"
          ? this.state.edited.refHfFrom.id
          : this.state.edited.refHfFrom),

      refHfToId:
        this.state.edited.refHfToId ||
        (typeof this.state.edited.refHfTo === "object"
          ? this.state.edited.refHfTo.id
          : this.state.edited.refHfTo),

      // Handle both ICD and diagnosisId to ensure compatibility
      icdId:
        this.state.edited.diagnosisId ||
        (typeof this.state.edited.icd === "object"
          ? this.state.edited.icd.id
          : this.state.edited.icd),

      diagnosisId:
        this.state.edited.diagnosisId ||
        (typeof this.state.edited.icd === "object"
          ? this.state.edited.icd.id
          : this.state.edited.icd),

      serviceId:
        this.state.edited.serviceId ||
        (typeof this.state.edited.service === "object"
          ? this.state.edited.service.id
          : this.state.edited.service),

      itemId:
        this.state.edited.itemId ||
        (typeof this.state.edited.item === "object"
          ? this.state.edited.item.id
          : this.state.edited.item),
    };
    const requiredFields = {
      insureeId: preauth.enrolleeId,
      refHfFromId: preauth.refHfFromId,
      refHfToId: preauth.refHfToId,
      diagnosisId: preauth.diagnosisId,
    };

    console.log("Required fields check:", requiredFields);

    const missingFields = Object.entries(requiredFields)
      .filter(([key, value]) => !value)
      .map(([key]) => key);

    if (missingFields.length > 0) {
      console.error("Missing required fields:", missingFields);
      return;
    }
    if (!preauth.serviceId && !preauth.itemId) {
      console.error("Either a service or an item is required", this.state.edited);
      return;
    }
    if (!preauth.enrolleeId) {
      console.error("Insuree ID is missing in the object", this.state.edited);
      return; // Prevent submission
    }

    this.props.savePREAUTHS(
      preauth,
      formatMessage(
        this.props.intl,
        "preauthorization",
        "CreatePreauth.mutationLabel"
      )
    );

    this.handleDisablePage();
  };
  //open confirm dialog
  handleOpen = () => {
    this.setState((prevState) => ({
      ...prevState,
      open: true,
    }));
  };

  //close confirm dialog
  handleClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  handleDisablePage = () => {
    this.setState((prevState) => ({
      ...prevState,
      disablePage: true,
    }));
  };

  updateAttribute = (k, v) => {
    console.log(`Updating attribute ${k} with value:`, v);

    // Create a new edited object to avoid state mutation issues
    let newEdited = { ...this.state.edited };

    // Handle special cases
    if (k === "enrollee" || k === "enrolleeId") {
      newEdited.enrollee = v;
      newEdited.insureeId = typeof v === "object" ? v.id : v;
    } else if (k === "icd") {
      console.log("ICD value received:", v);
      // Ensure both icd and diagnosisId are set
      newEdited.icd = v;
      newEdited.diagnosisId = v && typeof v === "object" ? v.id : v;
    } else if (k === "refHfFrom") {
      newEdited.refHfFrom = v;
      newEdited.refHfFromId = typeof v === "object" ? v.id : v;
    } else if (k === "refHfTo") {
      newEdited.refHfTo = v;
      newEdited.refHfToId = typeof v === "object" ? v.id : v;
    } else if (k === "service") {
      newEdited.service = v;
      newEdited.serviceId = typeof v === "object" ? v.id : v;
    } else if (k === "item") {
      newEdited.item = v;
      newEdited.itemId = typeof v === "object" ? v.id : v;
    } else {
      // Standard case
      newEdited[k] = v;
    }

    console.log("New edited state:", newEdited);
    this.setState({ edited: newEdited });
  };

  //send mutation for approving a preauthorization
  mutateApproved = () => {
    console.log("Object: ", this.state.edited),
      this.props.approvePreauthorization(
        this.state.edited,
        `Approved ${this.state.edited.insuree.lastName}`
      );
    this.handleDisablePage();
  };

  //send mutation for reject a preauthorization
  mutateReject = () => {
    // Check if we have enrollee data before trying to access lastName
    const lastName = this.state.edited?.insuree?.lastName || "preauthorization";

    this.props.rejectPreauthorization(
      this.state.edited,
      `Rejected ${lastName}`
    );
    this.handleDisablePage();
  };

  //function to decide if to pass approve or reject mutation to confirmation dialog
  handleAction = (action) => {
    if (action === "approve") {
      this.setState((prev) => ({
        ...prev,
        action: this.mutateApproved,
        open: true,
        title: "Approve",
      }));
    } else if (action === "reject") {
      this.setState((prev) => ({
        ...prev,
        action: this.mutateReject,
        open: true,
        title: "Reject",
      }));
    }
  };

  //reroute to main page
  pushToMainPage = () => {
    historyPush(
      this.props.modulesManager,
      this.props.history,
      "preauthorization.route.preauthorization"
    );
  };

  render() {
    const { classes, reset, intl, rights, mutation, userClaimAdmin } = this.props;
    const { edited } = this.state;
    const isEntered = edited.praStatus == "E";
    const isClaimAdmin = !!userClaimAdmin;
    const canApprove =
      isEntered &&
      !this.state.disablePage &&
      isClaimAdmin &&
      rights.includes(RIGHT_PREAUTHORIZATION_APPROVE);
    const canReject =
      isEntered &&
      !this.state.disablePage &&
      isClaimAdmin &&
      rights.includes(RIGHT_PREAUTHORIZATION_REJECT);
    return (
      <div className={classes.page} style={{ marginTop: "1.5em" }}>
        <Grid container>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <div className={classes.titleBar}>
                <IconButton
                  className={classes.backButton}
                  onClick={this.pushToMainPage}
                  aria-label="back"
                  size="small"
                >
                  <ArrowBackIosIcon fontSize="medium" />
                </IconButton>
                <Typography className={classes.titleText} variant="h6">
                  <FormattedMessage
                    module="preauthorization"
                    id={
                      this.state.preauth_uuid
                        ? "menu.editPreauthorization"
                        : "menu.addPreauthorization"
                    }
                  />
                </Typography>
              </div>
              <Divider />
              <Grid container className={classes.item}>
                <ControlledField
                  module="PreAuth"
                  id="PreAuth.enrollee"
                  field={
                    <Grid item xs={3} className={classes.item}>
                      <PublishedComponent
                        pubRef="insuree.InsureePicker"
                        label={formatMessage(
                          intl,
                          "preauthorization",
                          "preauthorization.enrollee"
                        )}
                        value={
                          this.state.preauth_uuid
                            ? edited?.insuree
                            : edited?.enrollee
                        }
                        reset={reset}
                        onChange={(v, s) => this.updateAttribute("enrollee", v)}
                        required
                        readOnly={this.state.preauth_uuid}
                      />
                    </Grid>
                  }
                />
                <Grid item xs={3} className={classes.item}>
                  <PublishedComponent
                    pubRef="location.HealthFacilityPicker"
                    label={formatMessage(
                      intl,
                      "preauthorization",
                      "preauthorization.RefferingHF"
                    )}
                    value={edited?.refHfFrom}
                    reset={reset}
                    onChange={(v, s) => this.updateAttribute("refHfFrom", v)}
                    required
                    readOnly={this.state.preauth_uuid}
                  />
                </Grid>
                <Grid item xs={3} className={classes.item}>
                  <PublishedComponent
                    pubRef="location.HealthFacilityPicker"
                    label={formatMessage(
                      intl,
                      "preauthorization",
                      "preauthorization.ReceivingHF"
                    )}
                    value={edited?.refHfTo}
                    reset={reset}
                    onChange={(v, s) => this.updateAttribute("refHfTo", v)}
                    required
                    readOnly={this.state.preauth_uuid}
                  />
                </Grid>
                <Grid item xs={3} className={classes.item}>
                  <PublishedComponent
                    pubRef="medical.DiagnosisPicker"
                    name="mainDiagnosis"
                    value={edited?.icd}
                    reset={reset}
                    onChange={(v) => {
                      console.log("DiagnosisPicker returned value:", v);
                      this.updateAttribute("icd", v);
                    }}
                    required
                    readOnly={this.state.preauth_uuid}
                  />
                </Grid>
                <Grid item xs={3} className={classes.item}>
                  <PublishedComponent
                    pubRef="medical.ServicePicker"
                    name="Service"
                    value={edited?.service}
                    reset={reset}
                    onChange={(v, s) => this.updateAttribute("service", v)}
                    readOnly={this.state.preauth_uuid}
                  />
                </Grid>
                <Grid item xs={3} className={classes.item}>
                  <PublishedComponent
                    pubRef="medical.ItemPicker"
                    name="Item"
                    value={edited?.item}
                    reset={reset}
                    onChange={(v, s) => this.updateAttribute("item", v)}
                    readOnly={this.state.preauth_uuid}
                  />
                </Grid>
                <Grid item xs={3} className={classes.item}>
                  <TextInput
                    value={
                      edited.praStatus
                        ? formatMessage(
                            this.props.intl,
                            "preauthorization",
                            `preauthorization.Status.${edited.praStatus}`
                          )
                        : ""
                    }
                    label={"preauthorization.Status"}
                    readOnly
                  />
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <TextInput
                    value={edited.explanation}
                    label={formatMessage(
                      this.props.intl,
                      "preauthorization",
                      "preauthorization.explanation"
                    )}
                    readOnly={edited.praStatus != "E" || this.state.disablePage}
                    onChange={(v) => this.updateAttribute("explanation", v)}
                  />
                </Grid>
                {edited.praStatus != "A" && this.state.preauth_uuid && (
                  <Grid item xs={6} className={classes.item}>
                    <TextInput
                      value={edited.reasonForReject}
                      label={formatMessage(
                        this.props.intl,
                        "preauthorization",
                        "preauthorization.ReasonForRejection"
                      )}
                      readOnly={
                        edited.praStatus != "E" || this.state.disablePage
                      }
                      onChange={(v) =>
                        this.updateAttribute("reasonForReject", v)
                      }
                    />
                  </Grid>
                )}
              </Grid>
              {/* Mutation comfirmation dialog */}
              <PreauthorizationConfirmation
                handleOpen={this.handleOpen}
                handleClose={this.handleClose}
                title={this.state.title}
                open={this.state.open}
                action={this.state.action}
              />
              <div
                style={{
                  display: "flex",
                  gap: "4em",
                  alignItems: "center",
                  justifyContent: "end",
                  padding: "2em",
                }}
              >
                {this.state.preauth_uuid && (isClaimAdmin || rights.includes(RIGHT_PREAUTHORIZATION_APPROVE) || rights.includes(RIGHT_PREAUTHORIZATION_REJECT)) && (
                  <div
                    style={{
                      display: "flex",
                      gap: "2.5em",
                      justifyContent: "end",
                      padding: "2em",
                    }}
                  >
                    {rights.includes(RIGHT_PREAUTHORIZATION_APPROVE) && (
                    <button
                      style={{
                        padding: "8px 16px",
                        width: "90px",
                        background: `${
                          !canApprove
                            ? "grey"
                            : "#006273"
                        }`,
                        border: "solid 2px transparent",
                        borderRadius: "5px",
                        cursor: `${!canApprove ? "" : "pointer"}`,
                        color: "white",
                      }}
                      onClick={() => this.handleAction("approve")}
                      disabled={!canApprove}
                      title={
                        !isClaimAdmin
                          ? "Only claim administrators can approve preauthorizations"
                          : ""
                      }
                    >
                      Approve
                    </button>
                    )}

                    {rights.includes(RIGHT_PREAUTHORIZATION_REJECT) && (
                    <button
                      style={{
                        padding: "5px 16px",
                        width: "90px",
                        background: `${
                          !canReject
                            ? "grey"
                            : "red"
                        }`,
                        border: `${
                          !canReject ? "grey" : "#006273"
                        }`,
                        borderRadius: "5px",
                        cursor: `${!canReject ? "" : "pointer"}`,
                        color: "white",
                      }}
                      onClick={() => this.handleAction("reject")}
                      disabled={!canReject}
                      title={
                        !isClaimAdmin
                          ? "Only claim administrators can reject preauthorizations"
                          : ""
                      }
                    >
                      Reject
                    </button>
                    )}
                  </div>
                )}
                {edited.praStatus == "E" && (
                  <Fab
                    color="primary"
                    disabled={this.state.disablePage}
                    onClick={this.save}
                  >
                    <Save />
                  </Fab>
                )}
              </div>
            </Paper>
          </Grid>
        </Grid>

        {this.state.showPopUp && mutation?.clientMutationId && (
          <PublishedComponent
            pubRef="info.notification"
            mutation={mutation}
            errorMessage={"Failed to create preauthorization"}
          />
        )}
        <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  rights:
    !!state.core && !!state.core.user && !!state.core.user.i_user
      ? state.core.user.i_user.rights
      : [],
  preauthorizations: state.preauthorization.preauthorizations,
  mutation: state.preauthorization.mutation,
  submittingMutation: state.preauthorization.submittingMutation,
  userClaimAdmin: state.preauthorization.userClaimAdmin,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      savePREAUTHS,
      fetchMyPreauthorization,
      rejectPreauthorization,
      approvePreauthorization,
      fetchUserClaimAdmin,
      journalize,
    },
    dispatch
  );
};

export default withTheme(
  injectIntl(
    withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AddPreauth))
  )
);
